import antdItIT from 'antd/es/locale/it_IT';
import itMsg from '../locales/it_IT/index';

const ItLang = {
  antd: antdItIT,
  locale: 'it-IT',
  messages: {
    ...itMsg,
  },
};
export default ItLang;
